import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref, withDefaults } from 'vue';

type Props = {
    showCloseButton?: boolean|string;
    anchor?: HTMLElement|null;
    horizontalAnchorAlignment?: 'left' | 'center' | 'right';
    verticalAnchorAlignment?: 'top' | 'bottom';
    verticalAlignmentMobile?: 'top' | 'center' | 'bottom';
}
type Emits = {
    (e: 'close'): void;
}
type Position = {
    left?: string;
    top?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BubbleMenu',
  props: {
    showCloseButton: { type: [Boolean, String], default: false },
    anchor: { default: null },
    horizontalAnchorAlignment: { default: 'left' },
    verticalAnchorAlignment: { default: 'bottom' },
    verticalAlignmentMobile: { default: 'bottom' }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { showCloseButton: boolean|string, anchor: HTMLElement|null, horizontalAnchorAlignment: 'left' | 'center' | 'right', verticalAnchorAlignment: 'top' | 'bottom', verticalAlignmentMobile: 'top' | 'center' | 'bottom' };




const position = ref<Position>({});

const menu = ref<HTMLElement | null>(null);

onMounted(() => {
    calculatePosition();
    window.addEventListener('resize', close, { passive: true });
    window.addEventListener('scroll', close, { passive: true });
});

onUnmounted(() => {
    window.removeEventListener('resize', close);
    window.removeEventListener('scroll', close);
    close();
});

function calculatePosition() {
    if (!props.anchor || !menu.value) return;

    const menuBoundingRect = menu.value.getBoundingClientRect();
    const anchorBoundingRect = props.anchor.getBoundingClientRect();
    position.value = {
        left: `${calcX(anchorBoundingRect, menuBoundingRect)}px`,
        top: `${calcY(anchorBoundingRect, menuBoundingRect)}px`,
    };
}

function calcX(anchorRect: DOMRect, menuRect: DOMRect): number {
    let preferred;
    switch (props.horizontalAnchorAlignment) {
        case 'left': preferred = anchorRect.left + anchorRect.width - menuRect.width; break;
        case 'center': preferred = anchorRect.left + anchorRect.width / 2 - menuRect.width / 2; break;
        case 'right': preferred = anchorRect.left + anchorRect.width; break;
        default: preferred = 0;
    }
    if (preferred < 0) {
        return 0;
    }
    // subtract 2 * 1rem padding
    const windowMax = window.innerWidth - 2 * convertRemToPixels(1);
    if (preferred + menuRect.width > windowMax) {
        return windowMax - menuRect.width;
    }
    return preferred;
}

function calcY(anchorRect: DOMRect, menuRect: DOMRect): number {
    let preferred;
    switch (props.verticalAnchorAlignment) {
        case 'bottom': preferred = anchorRect.top + anchorRect.height; break;
        case 'top': preferred = anchorRect.top - menuRect.height; break;
        default: preferred = 0;
    }
    if (preferred < 0) {
        return 0;
    }
    // subtract 2 * 1rem padding
    const windowMax = window.innerHeight - 2 * convertRemToPixels(1);
    if (preferred + menuRect.height > windowMax) {
        return windowMax - menuRect.height;
    }
    return preferred;
}

function convertRemToPixels(rem: number) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

function close() {
    emits('close');
}

return { __sfc: true,props, emits, position, menu, calculatePosition, calcX, calcY, convertRemToPixels, close }
}

})